export const noop = () => {
    /* noop */
};

export const noopFactory = () => () => {
    /* noop */
};
